import React from "react";
import MPMC from "../../PicesForPages/MonthlyPaymentCalculator.jpg";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
// import MortgageCalculator, {
//   MortgageCalculator2,
// } from "../CalculatorAndChart/mortgageCalculator";

function MonthlyPaymentMortgageCalculator() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={MPMC}
          alt="MPMCImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Monthly Payment Calculator</span>
        </div>
      </div>
      <MortgageCalculator />
      {/* <MortgageCalculator2 /> */}
    </div>
  );
}

export default MonthlyPaymentMortgageCalculator;
